<template>
<div v-if="page.career" class="page-career">
  <div class="container page-career-pseudo">
    <CareerMainText/>
  </div>

  <div class="container">

    <div v-if="!mobile" class="page-career--man">
      <div :class="`page-career--man-body page-career--man-body-${careerSlide === 0 ? 'active' : ''}`">
        <img src="/static/career/career-student-white.svg"/>
      </div>
      <div :class="`page-career--man-body page-career--man-body-${careerSlide === 1 ? 'active' : ''}`">
        <img src="/static/career/career-spec-white.svg"/>
      </div>
      <div :class="`page-career--man-body page-career--man-body-${careerSlide === 2 ? 'active' : ''}`">
        <img src="/static/career/career-pro-white.svg"/>
      </div>
    </div>

  </div>

 </div>
</template>

<script>
import { mapGetters } from 'vuex';

import CareerMainText from '@/components/CareerMainText';

export default {
  name: 'career',
  computed: mapGetters({
    careerSlide: 'careerSlide',
    mobile: 'mobile',
    page: 'page',
  }),
  components: {
    CareerMainText,
  },
};
</script>


<style>
.page-pseudo{
  background: none;
}

  .page-theme-dark .page-pseudo{
    .page-career--man{
      opacity: 0;
    }
  }

.page-career{

  .page-theme-white &.page-dark{
    .page-career--man{
      opacity: 0;
    }
  }

  &-pseudo{
    pointer-events: none;
    opacity: 0;
  }


  &--man{
    transition: opacity 1.5s ease-in-out;
    position: absolute;
    z-index: -1;
    left: 49vw;
    bottom: 50%;

    @media (min-width: $mediaSmallScreen) {
      left: 52vw;
      bottom: 70%;
    }

    @media (max-width: $mediaIpad) {
      left: 62vw;
      bottom: 35%;
    }

    @media (max-width: $mediaMob) {
      bottom: 20%;
    }

    @media (max-width: $mediaMini) {
      bottom: 30%;
      left: 55vw;
    }

    @media (max-width: $mediaTiny) {
      display: none;
    }

    @media (min-width: 1600px) {
      left: 800px;
    }


    img,
    svg{
      width: 50vw;
      min-width: 200px;

      @media (min-width: $mediaSmallScreen) {
        max-width: 800px;
        width: 48vw;
      }

      @media (max-width: $mediaIpad) {
        width: 40vw;
      }
    }

    &-body{
      transition: all .3s ease-in-out;
      display: -ms-inline-flexbox;
      transform: scale(.9);
      position: absolute;
      opacity: 0;
      left: 0;
      top: 0;

      &-active{
        transform: none;
        opacity: 1;
      }
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/pages/CareerImages.vue